'use strict';

import { BoxGeometry } from 'three';
import { ObjectCore } from './ObjectCore';

export class Box extends ObjectCore{

  constructor (data,textureLoader) {
    const geometry = new BoxGeometry(5,5,5);

    super(data,geometry,textureLoader);

    this.objectType = 'Box';
  }

}
